module.exports = __webpack_public_path__ + "static/amy_dix-a2ab93aee1544ab1b8235251a4d96e27.jpg";